<template>
  <div class="telegraphs">
    <template>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" forceRender>
          <span slot="tab">
            <a-icon type="smile" theme="twoTone" />
            每日动态
          </span>
          <Everyday />
        </a-tab-pane>
        <!-- <a-tab-pane key="2" forceRender>
          <span slot="tab">
            <a-icon type="usb" theme="twoTone" />
            资源共享
          </span>
          <SendShare />
        </a-tab-pane> -->
        <a-tab-pane key="3">
          <span slot="tab">
            <a-icon type="bug" theme="twoTone" />
            <!-- <a-icon type="android" /> -->
            架构领域
          </span>
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>

<script>
import everyday from "@/components/user/usercolumn/release/telegraphs/everyday"
export default {
  name: "telegraphs",
  data() {
    return {
      telegraphs: "故事",
    };
  },

  components:{
    Everyday:everyday,
  }
};
</script>

<style lang="less" scoped>
.telegraphs {
  // width: 100%;
  // height: 500px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/telegraphs/telegraphs.vue